import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { listServices, getServiceBySlug } from '../services/services';
import type { AudienceType } from '../types/api';

export function useServices(audience?: AudienceType) {
  const { i18n } = useTranslation();
  const lang = i18n.language as 'th' | 'en';
  return useQuery({
    queryKey: ['services', audience, lang],
    queryFn: () => listServices({ audience, lang }),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}

export function useService(slug: string) {
  const { i18n } = useTranslation();
  const lang = i18n.language as 'th' | 'en';
  return useQuery({
    queryKey: ['services', slug, lang],
    queryFn: () => getServiceBySlug(slug, lang),
    enabled: !!slug,
    staleTime: 10 * 60 * 1000, // 10 minutes
  });
}
